import { Component } from '@angular/core';
import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-filter-help',
  standalone: true,
  imports: [FooterComponent],
  templateUrl: './filter-help.component.html',
  styleUrl: './filter-help.component.scss'
})
export class FilterHelpComponent {

}
